import { generateIconComponent } from './icons.utils';

export const ChevronUpSolidIcon = generateIconComponent({
    name: 'ChevronUpSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M23.678 17.1212L22.1212 18.678C21.6918 19.1073 20.9937 19.1073 20.5643 18.678L12.0008 10.1126L3.4373 18.678C3.00571 19.1073 2.30988 19.1073 1.8805 18.678L0.323692 17.1212C-0.107897 16.6919 -0.107897 15.9939 0.323692 15.5645L10.444 5.44234C10.8558 5.03059 11.4173 4.79719 12.0008 4.79719C12.5844 4.79719 13.1437 5.03059 13.5576 5.44234L23.678 15.5645C24.1073 15.9939 24.1073 16.6919 23.678 17.1212Z" />
    ),
});
